import { render, staticRenderFns } from "./option.vue?vue&type=template&id=66cfbbc0&scoped=true"
import script from "./option.vue?vue&type=script&lang=js"
export * from "./option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cfbbc0",
  null
  
)

export default component.exports